// src/labels.js
export const LABELS = {
  HIS: {
    fr: "Histoire",
    en: "History",
    color: "bg-yellow-100 text-yellow-800",
    sub: {
      HIS_INV: { fr: "Inventions & découvertes", en: "Inventions & Discoveries" },
      HIS_EVT: { fr: "Événements & guerres", en: "Events & Wars" },
      HIS_PER: { fr: "Personnalités", en: "People" }
    }
  },

  SCI: {
    fr: "Sciences",
    en: "Science",
    color: "bg-green-100 text-green-800",
    sub: {
      SCI_BIO: { fr: "Biologie", en: "Biology" },
      SCI_PHY: { fr: "Physique & Chimie", en: "Physics & Chemistry" },
      SCI_AST: { fr: "Astronomie", en: "Astronomy" }
    }
  },

  MAT: {
    fr: "Mathématiques",
    en: "Mathematics",
    color: "bg-blue-100 text-blue-800",
    sub: {
      MAT_ARI: { fr: "Arithmétique", en: "Arithmetic" },
      MAT_GEO: { fr: "Géométrie", en: "Geometry" },
      MAT_PROB: { fr: "Probabilités & Statistiques", en: "Probability & Statistics" }
    }
  },

  POL: {
    fr: "Politique",
    en: "Politics",
    color: "bg-red-100 text-red-800",
    sub: {
      POL_INST: { fr: "Institutions", en: "Institutions" },
      POL_ECO: { fr: "Économie publique", en: "Public Economy" },
      POL_INT: { fr: "Relations internationales", en: "International Relations" }
    }
  },

  CUL: {
    fr: "Culture",
    en: "Culture",
    color: "bg-purple-100 text-purple-800",
    sub: {
      CUL_LIT: { fr: "Littérature", en: "Literature" },
      CUL_ART: { fr: "Arts & Musique", en: "Arts & Music" },
      CUL_CIN: { fr: "Cinéma", en: "Cinema" }
    }
  },

  VIE: {
    fr: "Vie pratique",
    en: "Everyday life",
    color: "bg-orange-100 text-orange-800",
    sub: {
      VIE_CUI: { fr: "Cuisine", en: "Cooking" },
      VIE_SAN: { fr: "Santé", en: "Health" },
      VIE_CON: { fr: "Organisation & Conseils", en: "Organization & Tips" }
    }
  },

  ACT: {
    fr: "Actualité",
    en: "Current events",
    color: "bg-pink-100 text-pink-800",
    sub: {
      ACT_ACTU: { fr: "Questions d'actualité", en: "News & Current Affairs" }
    }
  },

  SEN: {
    fr: "Sujets sensibles",
    en: "Sensitive topics",
    color: "bg-red-100 text-red-800",
    sub: {
      ACT_SENS: { fr: "Sujet sensible", en: "Sensitive topic" },
      SEN_SEX: { fr: "Sexualité et contenu sexuel", en: "Sexuality and sexual content" },
      SEN_HATE: { fr: "Haine et discrimination", en: "Hate and discrimination" },
      SEN_VIO: { fr: "Violence et menaces", en: "Violence and threats" },
      SEN_SAFE: { fr: "Sécurité et comportements à risque", en: "Safety and risky behaviour" },
      SEN_PER: { fr: "Données personnelles et manipulation", en: "Personal data and manipulation" }
    }
  },

  AUT: {
    fr: "Autres / Social",
    en: "Other / Social",
    color: "bg-gray-100 text-gray-800",
    sub: {
      AUT_GEN: { fr: "Discussions générales / sociales", en: "General / Social Discussions" }
    }
  },

  SPO: {
    fr: "Sport",
    en: "Sports",
    color: "bg-sky-100 text-sky-800",
    sub: {
      SPO_EVT: { fr: "Événements sportifs", en: "Sporting Events" },
      SPO_PER: { fr: "Performances / athlètes", en: "Performances / Athletes" },
      SPO_ACT: { fr: "Actualité sportive", en: "Sports News" },
      SPO_TECH: { fr: "Techniques sportives", en: "Sports Techniques" }
    }
  },

  TEC: {
    fr: "Technologie & Informatique",
    en: "Technology & Computing",
    color: "bg-indigo-100 text-indigo-800",
    sub: {
      TEC_INF: { fr: "Informatique générale (systèmes, programmation)", en: "General Computing (systems, programming)" },
      TEC_WEB: { fr: "Web, applications, réseaux", en: "Web, Apps & Networks" },
      TEC_IA: { fr: "Intelligence artificielle, données", en: "Artificial Intelligence & Data" },
      TEC_OBJ: { fr: "Objets connectés, robotique, électronique", en: "IoT, Robotics & Electronics" },
      TEC_GAME: { fr: "Jeux vidéo", en: "Video Games" }
    }
  }
};
